import { formatDuration as formatDurationFns, Duration } from "date-fns";
import { es } from "date-fns/locale";

/**
 * Formats a duration in minutes to a human-readable string
 * @param minutes - The duration in minutes
 * @returns Formatted duration string (e.g., "2h 30min") or "N/D" if invalid
 */
export const formatDuration = (minutes: number): string => {
  if (minutes < 0 || !Number.isFinite(minutes)) {
    return "0h";
  }

  if (minutes === 0) {
    return "0h";
  }

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  const duration: Duration = {
    hours,
    minutes: mins,
  };

  return formatDurationFns(duration, {
    format: ["hours", "minutes"],
    locale: es,
    zero: false,
  }).replace("horas", "h").replace("hora", "h").replace("minutos", "min").replace("minuto", "min");
};

